import { render, staticRenderFns } from "./InfoContacts.vue?vue&type=template&id=56050d66&"
import script from "./InfoContacts.vue?vue&type=script&lang=js&"
export * from "./InfoContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports